import {FilledInputProps, OutlinedInputProps} from "@material-ui/core";
import {DateField, DateInput, FieldProps, FunctionField, InputProps, Record,} from "react-admin";
import {useStore} from "./store";
import {useForm} from "react-final-form";
import {FormApi} from "final-form";

export const EditableDateField = (
  props: FieldProps & {
    source: string;
    getInputProps?: (
      record: Record,
      form: FormApi<
        globalThis.Record<string, any>,
        Partial<globalThis.Record<string, any>>
      >
    ) =>
      | Partial<InputProps>
      | Partial<FilledInputProps>
      | Partial<OutlinedInputProps>
      | undefined;
  }
) => {
  const { editable } = useStore();
  const form = useForm();
  const { getInputProps, ...rest } = props;
  return editable ? (
    <FunctionField
      {...rest}
      render={(record: Record | undefined) => (
        <DateInput
          size="small"
          variant="standard"
          label=""
          source={rest.source}
          helperText={false}
          onClick={(e) => e.stopPropagation()}
          InputProps={
            getInputProps && record ? getInputProps(record, form) : undefined
          }
        />
      )}
    />
  ) : (
    <DateField {...rest} />
  );
};
